import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import TextInput from '../../common/textinput';

class OrderComment extends React.PureComponent {
    static propTypes = {
        comment: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        max_length: PropTypes.number,
        t: PropTypes.func.isRequired,
    };

    render() {
        const { max_length, comment, onChange, t } = this.props;

        return (
            <div className="m2g-order-confirmation-comment">
                <TextInput
                    value={comment}
                    onChange={onChange}
                    max_length={max_length}
                    icon="comment"
                    element_props={{ placeholder: t('placeholder') }}
                />
            </div>
        );
    }
}

export default forwardRefWithTranslation('order.comment')(OrderComment);
